import React from 'react';
import PropTypes from 'prop-types';
import ConfirmDialogBase from './ConfirmDialogBase';

class ConfirmDialog extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override ConfirmDialogBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Dialog> */
    className: PropTypes.string,
    /** Open/close dialog */
    open: PropTypes.bool.isRequired,
    /** Text for the Dialog title */
    title: PropTypes.string,
    /** Optional icon rendered before the title text */
    titleIcon: PropTypes.node,
    /** Text for the cancel button */
    cancelText: PropTypes.string,
    /** Text for the confirm button */
    confirmText: PropTypes.string.isRequired,
    /** Callback fired when cancel button click */
    onCancel: PropTypes.func,
    /** Callback fired when confirm button click */
    onConfirm: PropTypes.func,
  };

  static defaultProps = {
    styleType: 'default',
  };

  getStyles = type => {
    switch (type) {
      case 'maintenance':
        return {
          contentText: {
            '& > .downtime-begin': {
              marginTop: '20px',
              marginBottom: '4px',
            },
            '& > .downtime-end': {
              margin: '0px',
            },
            '& span': {
              display: 'flex',
              '& b': {
                paddingRight: '5px',
              },
            },
          },
        };
      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <ConfirmDialogBase styles={styles} {...otherProps} />;
  }
}

export default ConfirmDialog;
